module.exports = __webpack_public_path__ + "media/images/lb/522-df79fef2e2576fa59b55b0c7fd87f229.svg";